import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { TankPlan } from 'src/types/ViewModel/Vessel/TankPlan';

export const getAllTanks = (tankPlan: TankPlan): Tank[] => {
    return tankPlan.tankColumns.flatMap((t) => t.tankRows.flatMap((tr) => tr.tanks)).concat(tankPlan.deckTanks.map((d) => d.tank));
};

export const getTank = (tankPlan: TankPlan, tankId: number): Tank | null => {
    return getAllTanks(tankPlan).find((t) => t.tankId === tankId) ?? null;
};
